import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prestacao-contas',
  templateUrl: './prestacao-contas.component.html',
  styleUrls: ['./prestacao-contas.component.css']
})
export class PrestacaoContasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
